export const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const fmtDay = (s) => (s ? new Date(s).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "—");
export const fmtDate = (s) => (s ? new Date(s).toLocaleString() : "—");
export const fmtMoney = (amount, currency = "NGN") => `${currency === "NGN" ? "₦" : currency + " "}${Number(amount || 0).toLocaleString()}`;

export function timeAgo(iso) {
  const s = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export function membershipLabel(m) {
  if (!m) return "";
  if (m.status === "trial") return `Free trial — ${m.days_left} day${m.days_left === 1 ? "" : "s"} left`;
  if (m.status === "active") return `${m.plan_name} until ${fmtDay(m.ends_at)}`;
  if (m.status === "exempt") return "Staff account";
  return m.plan_id === "trial" ? "Free trial ended" : "Membership expired";
}

export const passwordOk = (p) => p.length >= 8 && /[A-Za-z]/.test(p) && /\d/.test(p);
